import { Box, Picture, RatioContainer } from "@jewlr/storybook/core"
import styled from "styled-components"

import { jewlr_t } from "helpers/application"
import { SectionDescription, SectionTitle } from "jewlr/pages/components"

const PositionBlock = styled.div`
  position: absolute;
  text-align: center;
  top: 30px;
  width: 100%;
  z-index: 1;
  ${(props) => props.theme.mediaQueries.tablet`
    margin: 0;
    right: 8%;
    top: 50%;
    transform: translateY(-50%);
    width: 260px;
  `}
  ${(props) => props.theme.mediaQueries.desktop`
    right: 8%;
    width: 350px;
  `}
`
const TextBlock = styled.div`
  text-align: center;
`

const MainBanner = () => (
  <RatioContainer
    mb={{ _: 4, desktop: 6 }}
    pb={{ _: "125.16%", tablet: "41.59%", widescreen: "21.77%" }}
  >
    <div>
      <Box
        display={{ tablet: "flex" }}
        height="100%"
        justifyContent="center"
        position="relative"
      >
        <Picture
          fallback={`${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/top-banner/desktop_2x.jpg`}
          lazyload={false}
          srcSet={[
            {
              media: "(max-width: 767px)",
              sizes: "100vw",
              srcSet: `
              ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/top-banner/mobile.jpg 767w,
              ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/top-banner/mobile_2x.jpg 1534w
            `,
            },
            {
              media: "(min-width: 768px) and (max-width: 1279px)",
              sizes: "100vw",
              srcSet: `
              ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/top-banner/tablet.jpg 1005w,
              ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/top-banner/tablet_2x.jpg 2010w
            `,
            },
            {
              media: "(min-width: 1280px)",
              sizes: "100vw",
              srcSet: `
              ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/top-banner/desktop.jpg 1920w,
              ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/top-banner/desktop_2x.jpg 3840w
            `,
            },
          ]}
        />
        <Box contain height="100%" position="absolute" top="0" width="100%">
          <PositionBlock>
            <SectionTitle
              as="h1"
              fontSize={{ _: "30px", desktop: "34px" }}
              light
              lineHeight={1.2}
              mb={{ _: 1, desktop: "12px" }}
            >
              {jewlr_t("terms.Jewelry")}
              <Box as="br" display={{ _: "none", tablet: "block" }} /> For Her
            </SectionTitle>
            <SectionDescription
              fontSize={{ _: "16px", desktop: "18px" }}
              mb={0}
            >
              {jewlr_t("terms.Personalized")} {jewlr_t("terms.jewelry")} is
              <br />a meaningful gift for you or
              <br />
              someone you love.
            </SectionDescription>
          </PositionBlock>
        </Box>
      </Box>
    </div>
  </RatioContainer>
)

export default MainBanner
